import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountryPickerComponent } from './country-picker.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [CountryPickerComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [CountryPickerComponent],
})
export class CountryPickerModule { }
